import { StateCreator } from "zustand";
import { StorageValue } from "zustand/middleware";

import { serializeStore } from "@/utils/store";

import { QuotePersist } from "./types";

export type WithDevtoolsPersist<T, P> = StateCreator<
  T,
  [["zustand/devtools", never]],
  [["zustand/persist", P]],
  T
>;

export const sessionJSONStorage = {
  getItem: () => ({}) as StorageValue<QuotePersist>,
  setItem: (name: string, value: StorageValue<QuotePersist>) =>
    sessionStorage.setItem(name, serializeStore<QuotePersist>(value)),
  removeItem: (name: string) => sessionStorage.removeItem(name),
};
